import { MdOutlineClear } from 'react-icons/md';
import { Button } from '@ds';
import { FilterDropdown } from '@ui';
import { CountryStatePairFilter } from '@features/components/CountryStatePairFilter';
import { employeeMapper } from '@lp/features/admin/forms/utils';
import { HubListFilters } from '@/api/apis/facilities';
import { useInfiniteEmployeeListQuery } from '@/queries/employee';
import { useAllRegionsListQuery } from '@/queries/regions';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { UseFiltersType } from '@/hooks/useFilters';
import { getFormattedRegionsList } from '@/utils/helpers';
import { FILTERS_NAMES } from '../config';

type HubFiltersProps = UseFiltersType<HubListFilters>;

export const HubsFilters = ({ filters, hasFilters, updateFilters, clearFilters }: HubFiltersProps) => {
  const {
    list: managerList,
    isLoading,
    hasNextPage,
    loadNextPage,
    setSearchValue: onManagerSearch,
  } = useAsyncSearchableList({
    query: useInfiniteEmployeeListQuery,
    mapper: employeeMapper,
    defaultSortOrder: { orderBy: 'name', asc: true },
  });

  const { data: regionsList } = useAllRegionsListQuery();

  const formattedRegionsList = getFormattedRegionsList(regionsList);

  return (
    <div className="flex gap-7 items-center">
      <CountryStatePairFilter filters={filters} updateFilters={updateFilters} />
      <FilterDropdown
        title={FILTERS_NAMES.regionalManagers}
        items={managerList}
        selectedKeys={filters.regionalManagers}
        mode="multiple"
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        loadNextPage={loadNextPage}
        onSearchValue={onManagerSearch}
        onSelectedKeysChange={(values) => updateFilters(values, 'regionalManagers')}
      />
      <FilterDropdown
        title={FILTERS_NAMES.regions}
        items={formattedRegionsList}
        selectedKeys={filters.regions}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'regions')}
      />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
